(function () {
  var ROOT_SELECTOR = "[data-townwine-collectors]";
  function toArray(value) {
    return Array.prototype.slice.call(value || []);
  }
  function getCards(root) {
    return toArray(root.querySelectorAll("[data-collector-card]"));
  }
  function getSearchInput(root) {
    return root.querySelector("[data-collector-search]");
  }
  function getSortButtons(root) {
    return toArray(root.querySelectorAll("[data-collector-sort]"));
  }
  function getCountNode(root) {
    return root.querySelector("[data-collector-count]");
  }
  function getEmptyNode(root) {
    return root.querySelector("[data-collector-empty]");
  }
  function normalizeText(value) {
    return String(value || "")
      .trim()
      .toLowerCase();
  }
  function toInteger(value, fallback) {
    var parsedValue = Number(String(value || "").trim());
    return Number.isFinite(parsedValue) ? Math.trunc(parsedValue) : fallback;
  }
  function getSortValue(card, key, fallback) {
    if (!(card instanceof HTMLElement)) return fallback;
    var datasetValue = card.dataset[key];
    return datasetValue != null && datasetValue !== ""
      ? toInteger(datasetValue, fallback)
      : fallback;
  }
  function updateCount(root, visibleCount) {
    var countNode = getCountNode(root);
    countNode && (countNode.textContent = String(visibleCount));
  }
  function updateEmptyState(root, visibleCount) {
    var emptyNode = getEmptyNode(root);
    emptyNode && (emptyNode.hidden = visibleCount !== 0);
  }
  function applySortState(root, activeSort) {
    (getSortButtons(root).forEach(function (button) {
      var isActive = button.dataset.collectorSort === activeSort;
      (button.classList.toggle("is-on", isActive),
        button.setAttribute("aria-pressed", isActive ? "true" : "false"));
    }),
      (root.dataset.collectorActiveSort = activeSort));
  }
  function sortCards(root, activeSort) {
    var grid = root.querySelector("[data-collector-grid]"),
      cards = getCards(root);
    !grid ||
      !cards.length ||
      cards
        .sort(function (left, right) {
          if (activeSort === "deals") {
            var rightDealCount = getSortValue(right, "dealCount", 0),
              leftDealCount = getSortValue(left, "dealCount", 0),
              dealDelta = rightDealCount - leftDealCount;
            if (dealDelta !== 0) return dealDelta;
            var rightFollowerCountForDeals = getSortValue(
                right,
                "followerCount",
                0,
              ),
              leftFollowerCountForDeals = getSortValue(
                left,
                "followerCount",
                0,
              ),
              followerDeltaForDeals =
                rightFollowerCountForDeals - leftFollowerCountForDeals;
            if (followerDeltaForDeals !== 0) return followerDeltaForDeals;
          } else if (activeSort === "latest") {
            var latestDelta =
              getSortValue(left, "latestOrder", 9999) -
              getSortValue(right, "latestOrder", 9999);
            if (latestDelta !== 0) return latestDelta;
          } else {
            var rightFollowerCount = getSortValue(right, "followerCount", 0),
              leftFollowerCount = getSortValue(left, "followerCount", 0),
              followerDelta = rightFollowerCount - leftFollowerCount;
            if (followerDelta !== 0) return followerDelta;
            var rightDealCountForFollowers = getSortValue(
                right,
                "dealCount",
                0,
              ),
              leftDealCountForFollowers = getSortValue(left, "dealCount", 0),
              dealDeltaForFollowers =
                rightDealCountForFollowers - leftDealCountForFollowers;
            if (dealDeltaForFollowers !== 0) return dealDeltaForFollowers;
          }
          var sortDelta =
            toInteger(left.dataset.sortOrder, 999) -
            toInteger(right.dataset.sortOrder, 999);
          return sortDelta !== 0
            ? sortDelta
            : normalizeText(left.dataset.collectorName).localeCompare(
                normalizeText(right.dataset.collectorName),
              );
        })
        .forEach(function (card) {
          grid.appendChild(card);
        });
  }
  function revealRanking(root) {
    var widgets=Array.from(root.querySelectorAll('[data-townwine-collector-summary]'));
    if(widgets.length && widgets.every(function(widget){return widget.dataset.statsReady==='true';}) && !root.dataset.directoryLoading) root.setAttribute('data-ranking-ready','true');
  }
  function applyFilter(root) {
    var query = normalizeText((getSearchInput(root) || {}).value);
    var cards = getCards(root), matches = cards.filter(function(card) {return !query || normalizeText(card.dataset.searchIndex).includes(query);});
    var pages = Math.max(1, Math.ceil(matches.length / 24));
    var page = Math.min(Number(root.dataset.collectorPage || 1), pages);
    root.dataset.collectorPage = String(page);
    cards.forEach(function(card) {card.hidden = true;});
    matches.slice((page-1)*24,page*24).forEach(function(card) {card.hidden = false;});
    updateCount(root,matches.length); updateEmptyState(root,matches.length); revealRanking(root);
    var nav = root.querySelector('[data-collector-client-pages]');
    nav.replaceChildren(); nav.hidden = pages <= 1;
    function button(label,target) {
      var node = document.createElement('button'); node.type='button';node.className='chip';node.textContent=label;
      node.disabled=target<1||target>pages;
      if (label===String(page)) node.setAttribute('aria-current','page');
      node.addEventListener('click',function(){root.dataset.collectorPage=String(target);applyFilter(root);root.querySelector('[data-collector-grid]').scrollIntoView({block:'start'});});
      nav.appendChild(node);
    }
    button('이전',page-1);
    for(var i=1;i<=pages;i++) if(i===1||i===pages||Math.abs(i-page)<=1) button(String(i),i);
    button('다음',page+1);
  }
  async function loadAllCollectors(root) {
    var grid=root.querySelector('[data-collector-grid]'), source=root.querySelector('[data-collector-source-pages]');
    if(!source) return;
    source.hidden=true;root.dataset.directoryLoading="true";root.removeAttribute("data-ranking-ready");
    var status=root.querySelector('[data-collector-load-status]');status.textContent='전체 컬렉터를 확인하고 있습니다.';
    var first=new URL(window.location.href);first.searchParams.delete(grid.dataset.pageParam);first.hash='';
    var next=first.href, seen=new Set(), known=new Set(getCards(root).map(function(c){return c.querySelector('a').getAttribute('href');}));
    try {
      while(next && !seen.has(next)) {
        seen.add(next);
        var response=await fetch(next,{signal:AbortSignal.timeout(20000)});
        if(!response.ok) throw new Error('COLLECTORS_LOAD_FAILED');
        var doc=new DOMParser().parseFromString(await response.text(),'text/html');
        var incoming=doc.querySelector('[data-collector-grid]');if(!incoming) throw new Error('INVALID_COLLECTORS');
        incoming.querySelectorAll('[data-collector-card]').forEach(function(card){var key=card.querySelector('a').getAttribute('href');if(!known.has(key)){known.add(key);grid.appendChild(document.importNode(card,true));}});
        var link=doc.querySelector('[data-collector-source-pages] a[aria-label="다음 페이지"]');next=link?new URL(link.getAttribute('href'),first).href:null;
      }
      delete root.dataset.directoryLoading;root.dataset.collectorPage='1';
      sortCards(root,root.dataset.collectorActiveSort || 'followers');applyFilter(root);
      if(window.TownWineFollow) window.TownWineFollow.init(root);
      if(window.TownWineCollectorStats) window.TownWineCollectorStats.refresh(root);
      status.textContent='';
    } catch(error) {
      status.textContent='전체 목록을 불러오지 못했습니다. 새로고침해 주세요.';source.hidden=false;
    }
  }
  function initialize(root) {
    if (root instanceof HTMLElement && !root.dataset.directoryReady) {
      root.dataset.directoryReady="true";
      var activeSort = root.dataset.collectorActiveSort || "followers",
        searchInput = getSearchInput(root);
      (searchInput &&
        searchInput.addEventListener("input", function () {
          root.dataset.collectorPage="1"; applyFilter(root);
        }),
        getSortButtons(root).forEach(function (button) {
          button.addEventListener("click", function () {
            ((root.dataset.collectorPage="1"), (activeSort = button.dataset.collectorSort || "followers"),
              applySortState(root, activeSort),
              sortCards(root, activeSort),
              applyFilter(root));
          });
        }),
        applySortState(root, activeSort),
        sortCards(root, activeSort),
        applyFilter(root));
      loadAllCollectors(root);
    }
  }
  function boot(root) {
    toArray((root || document).querySelectorAll(ROOT_SELECTOR)).forEach(
      function (collectorRoot) {
        initialize(collectorRoot);
      },
    );
  }
  document.addEventListener('townwine:collector-stats-error',function(){document.querySelectorAll(ROOT_SELECTOR).forEach(function(root){if(!root.hasAttribute('data-ranking-ready')){var status=root.querySelector('[data-collector-ranking-status]');status.textContent='인기순 목록을 불러오지 못했어요. ';var retry=document.createElement('button');retry.type='button';retry.className='chip';retry.textContent='다시 불러오기';retry.onclick=function(){window.TownWineCollectorStats.refresh(root);status.textContent='팔로워 수를 다시 확인하고 있어요.';};status.appendChild(retry);}});});
  (document.addEventListener("shopify:section:load", function (event) {
    boot(event.target);
  }),
    document.addEventListener("townwine:collector-stats-updated", function () {
      toArray(document.querySelectorAll(ROOT_SELECTOR)).forEach(
        function (collectorRoot) {
          if (collectorRoot instanceof HTMLElement) {
            var activeSort =
              collectorRoot.dataset.collectorActiveSort || "followers";
            (sortCards(collectorRoot, activeSort), applyFilter(collectorRoot));
          }
        },
      );
    }),
    document.readyState === "loading"
      ? document.addEventListener("DOMContentLoaded", function () {
          boot(document);
        })
      : boot(document));
})();
//# sourceMappingURL=/cdn/shop/t/21/assets/townwine-collectors.js.map?v=13477745212866060031779459050
